import initState from "./initState";

import * as types from "./types";
import {
  updateObject,
  arrayToObject,
  deepCompare,
  removeItem,
  deepClone
} from "utils";

function fetchIRRecoveryPointsSuccess(state, action) {
  if (!deepCompare(state.currentRequest, action.params.requestConfigParams))
    return state;

  let updatedRecoveryPoints = { ...state.recoveryPoints };

  if (action.points.length > 0) {
    updatedRecoveryPoints.current = action.points[0];

    let devices = updatedRecoveryPoints.current.volumes;
    const updatedDevices = {};
    for (let key in devices) {
      updatedDevices[devices[key].deviceId] = devices[key];
      const volumes = {};

      for (let vol of updatedDevices[devices[key].deviceId].volume) {
        vol.checked = false;
        vol.restorePath = null;
        volumes[vol.volumeSerialNumber] = vol;
      }
      updatedDevices[devices[key].deviceId].volume = volumes;
    }

    updatedRecoveryPoints.current.volumes = updatedDevices;
    updatedRecoveryPoints.list = arrayToObject(action.points, "scheduleUUID");
  } else {
    updatedRecoveryPoints = initState.recoveryPoints;
    updatedRecoveryPoints.current = {};
  }

  return updateObject(state, {
    clientUUID: action.clientUUID,
    loading: false,
    transLoading: false,
    updatedVolumes: state.updatedVolumes.map(vol => {
      vol.selected = false;
      vol.for = "";
      return vol;
    }),
    checkedList: [],
    recoveryPoints: updatedRecoveryPoints
  });
}

function fetchIRRecoveryPointsFailure(state, action) {
  return updateObject(state, {
    loading: false,
    failed: {
      msg: action.data.msg,
      status: action.data.status
    }
  });
}

function updateIRRecoveryPointSuccess(state, action) {
  const updatedRecoveryPoints = { ...state.recoveryPoints };
  updatedRecoveryPoints.current = action.points[0];
  updatedRecoveryPoints.list[action.points[0].scheduleUUID].volumes =
    action.points[0].volumes;

  let devices = updatedRecoveryPoints.current.volumes;
  const updatedDevices = {};
  for (let key in devices) {
    updatedDevices[devices[key].deviceId] = devices[key];
    const volumes = {};

    for (let vol of updatedDevices[devices[key].deviceId].volume) {
      vol.checked = false;
      vol.restorePath = null;
      volumes[vol.volumeSerialNumber] = vol;
    }
    updatedDevices[devices[key].deviceId].volume = volumes;
  }

  updatedRecoveryPoints.current.volumes = updatedDevices;

  return updateObject(state, {
    loading: false,
    transLoading: false,
    updatedVolumes: state.updatedVolumes.map(vol => {
      vol.selected = false;
      vol.for = "";
      return vol;
    }),
    checkedList: [],
    recoveryPoints: updatedRecoveryPoints
  });
}

function changeIRRecoveryPoint(state, action) {
  const updatedCurrent = state.recoveryPoints.list[action.scheduleUUID];
  const updatedDisks = { ...updatedCurrent.volumes };

  for (let key in updatedDisks) {
    const disk = updatedDisks[key];

    for (let volKey in disk.volume) {
      const volume = disk.volume[volKey];
      volume.checked = false;
      volume.restorePath = null;
    }
  }

  updatedCurrent.volumes = updatedDisks;

  return updateObject(state, {
    loading: false,
    updatedVolumes: state.updatedVolumes.map(vol => {
      vol.selected = false;
      vol.for = "";
      return vol;
    }),
    checkedList: [],
    recoveryPoints: updateObject(state.recoveryPoints, {
      current: updatedCurrent
    })
  });
}

function fetchIRRecoveryPointsStart(state, action) {
  return updateObject(state, {
    loading: action.params.onMount ? true : false,
    transLoading: action.params.onMount ? false : true
  });
}

function storeIRRestoreParams(state, action) {
  return updateObject(state, {
    currentRequest: action.params
  });
}

function populateUpdatedVolumes(state, action) {
  return updateObject(state, {
    requestedUpdatedVolumes: updateObject(state.requestedUpdatedVolumes, {
      [action.client.clientUUID]: {
        isRequested: false
      }
    }),
    loading: state.recoveryPoints.current ? false : state.failed ? false : true,
    updatedVolumes:
      state.currentRequest &&
      state.targetMachine &&
      state.targetMachine.clientUUID === action.client.clientUUID
        ? action.client.volumes.map(vol => {
            vol.selected = false;
            return vol;
          })
        : state.updatedVolumes
  });
}

function toggleVolumeImageRestore(state, action) {
  const updatedVolume =
    state.recoveryPoints.current.volumes[action.deviceId].volume[
      action.volumeId
    ];
  let updatedCheckedList = [...state.checkedList];
  let restorePath = null;

  updatedVolume.checked = !updatedVolume.checked;

  if (updatedVolume.checked) updatedCheckedList.push(updatedVolume);
  else {
    const index = updatedCheckedList.indexOf(updatedVolume);
    if (index > -1) {
      updatedCheckedList = removeItem(updatedCheckedList, index);
    }
    if (updatedVolume.restorePath) {
      restorePath = updatedVolume.restorePath;
      updatedVolume.restorePath = null;
    }
  }

  return updateObject(state, {
    checkedList: updatedCheckedList,
    updatedVolumes: state.updatedVolumes.map(vol => {
      if (restorePath && vol.name === restorePath.name) {
        vol.selected = false;
        vol.for = "";
      }

      return vol;
    }),
    recoveryPoints: updateObject(state.recoveryPoints, {
      current: updateObject(state.recoveryPoints.current, {
        volumes: updateObject(state.recoveryPoints.current.volumes, {
          [action.deviceId]: updateObject(
            state.recoveryPoints.current.volumes[action.deviceId],
            {
              volume: updateObject(
                state.recoveryPoints.current.volumes[action.deviceId].volume,
                {
                  [action.volumeId]: updatedVolume
                }
              )
            }
          )
        })
      })
    })
  });
}

function changeTargetVolume(state, action) {
  for (let key in state.recoveryPoints.current.volumes) {
    const disk = state.recoveryPoints.current.volumes[key];

    for (let volKey in disk.volume) {
      const volume = disk.volume[volKey];
      if (
        volume.restorePath &&
        volume.restorePath.name === action.targetVol.name
      )
        return state;
    }
  }

  const updatedVolume =
    state.recoveryPoints.current.volumes[action.deviceId].volume[
      action.volumeId
    ];
  updatedVolume.restorePath = {
    name: action.targetVol.name,
    label: action.targetVol.label
  };

  return updateObject(state, {
    updatedVolumes: state.updatedVolumes.map(vol => {
      if (vol.for && vol.for === updatedVolume.name) {
        vol.selected = false;
        vol.for = "";
      }

      if (vol.name === action.targetVol.name) {
        vol.selected = true;
        vol.for = updatedVolume.name;
      }

      return vol;
    }),
    recoveryPoints: updateObject(state.recoveryPoints, {
      current: updateObject(state.recoveryPoints.current, {
        volumes: updateObject(state.recoveryPoints.current.volumes, {
          [action.deviceId]: updateObject(
            state.recoveryPoints.current.volumes[action.deviceId],
            {
              volume: updateObject(
                state.recoveryPoints.current.volumes[action.deviceId].volume,
                {
                  [action.volumeId]: updatedVolume
                }
              )
            }
          )
        })
      })
    })
  });
}

function clearImageRestore() {
  return initState;
}

function machineOfflineIR(state) {
  return updateObject(state, {
    ...initState,
    loading: false
  });
}

function changeIRTargetMachine(state, action) {
  if (!action.client) return state;
  return updateObject(state, {
    targetMachine: action.client
  });
}

function fetchUpdatedVolumes(state, action) {
  return updateObject(state, {
    requestedUpdatedVolumes: updateObject(state.requestedUpdatedVolumes, {
      [state.targetMachine.clientUUID]: {
        isRequested: true
      }
    }),
    updatedVolumes: []
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_IR_RECOVERY_POINTS_START:
      return fetchIRRecoveryPointsStart(state, action);
    case types.FETCH_IR_RECOVERY_POINTS_SUCCESS:
      return fetchIRRecoveryPointsSuccess(state, action);
    case types.FETCH_IR_RECOVERY_POINTS_FAILURE:
      return fetchIRRecoveryPointsFailure(state, action);
    case types.CHANGE_IR_RECOVERY_POINT:
      return changeIRRecoveryPoint(state, action);
    case types.UPDATE_IR_RECOVERY_POINT_SUCCESS:
      return updateIRRecoveryPointSuccess(state, action);
    case types.STORE_IR_REQUEST_PARAMS:
      return storeIRRestoreParams(state, action);
    case types.POPULATE_UPDATED_VOLUMES:
      return populateUpdatedVolumes(state, action);
    case types.TOGGLE_VOLUME_IMAGE_RESTORE:
      return toggleVolumeImageRestore(state, action);
    case types.CHANGE_TARGET_VOLUME:
      return changeTargetVolume(state, action);
    case types.CLEAR_IMAGE_RESTORE:
      return clearImageRestore();
    case types.MACHINE_OFFLINE_IR:
      return machineOfflineIR(state);
    case types.CHANGE_IMAGE_RESTORE_TARGET_MACHINE:
      return changeIRTargetMachine(state, action);
    case types.FETCH_UPDATED_VOLUMES:
      return fetchUpdatedVolumes(state, action);
    default:
      return state;
  }
}

export default reducer;
